export const siteKey = "6LegtacUAAAAAA3o6fxuVekMul0zbh2-gckKqneO";
export const secretKey = "6LegtacUAAAAAHzEOpNPyYf5Z5c-5EfWMwDEhF6m";